import { Config } from 'mixpanel-browser';

export function sessionReplayConfig(recordSessionsPercent: number): Partial<Config> {
  return {
    record_sessions_percent: Math.max(Math.min(recordSessionsPercent, 100), 0),
    record_collect_fonts: true,
    record_canvas: false,
    record_mask_text_selector:
      '.MuiTypography-root:not([data-test="nav-bar-label"], .h2), .label-text, .info-label, [role="tooltip"], [role="textbox"], [role="columnheader"], .field-control, .MuiPaper-root'
  };
}
